import Quotes from "./Quotes";

export { Quotes };



// WEBPACK FOOTER //
// ./src/components/quotes/index.ts